module.exports = __webpack_public_path__ + "img/mobile-action.4106940d.png";